import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

/**
 * DatePipe: date time without TimeZone doesn't work with IOS
 */

@Pipe({ name: 'localDate' })
export class LocalDatePipe implements PipeTransform {
    constructor(private datePipe: DatePipe) {}

    transform(value: any, pattern?: string) {
        return this.datePipe.transform(this.toUtc(value), pattern);
    }

    private toUtc(value: any) {
        try {
            return value ? moment(value).utc(false).format() : value;
        } catch (e) {
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/pipes/local-date.pipe.ts